// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questionnaire-container {
    flex-direction: column;
    padding: 30px;
    border-radius: 10px;
    margin: 20px auto;
}

.questionnaire-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
}

.questionnaire-bar-chart {
    width: 80%;
    padding: 20px;
    /*border-radius: 8px;*/
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCSS/QuestionnairesCounts.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,wCAAwC;AAC5C","sourcesContent":[".questionnaire-container {\n    flex-direction: column;\n    padding: 30px;\n    border-radius: 10px;\n    margin: 20px auto;\n}\n\n.questionnaire-title {\n    font-size: 24px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.questionnaire-bar-chart {\n    width: 80%;\n    padding: 20px;\n    /*border-radius: 8px;*/\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
